import Index from '@tunnel-components/@pages/tools/citilogIncident/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/tools/citilogIncident/home/index.ts